import Vue from 'vue'
import Utils from './Utils'
import Auth from './Auth'
export default {
  url: Auth.getUrl('message'),
  get (id) {
    return Vue.http.get(this.url + '/' + id)
  },
  preview (id, type) {
    return Vue.http.get(this.url + '/' + id + '/preview/' + type)
  },
  paginate (meta) {
    return Utils.paginate(this.url, meta)
  },
  paginateSendLog (id, meta) {
    return Utils.paginate(this.url + '/' + id + '/send-log', meta)
  },
  paginateSendTo (id, meta) {
    return Utils.paginate(this.url + '/' + id + '/paginate-to-send', meta)
  },
  toSendTotal (id) {
    return Vue.http.get(this.url + '/' + id + '/to-send-total')
  },
  test (id, data) {
    return Vue.http.post(this.url + '/' + id + '/test', data)
  },
  create (data) {
    return Vue.http.post(this.url, data)
  },
  update (data) {
    return Vue.http.put(this.url + '/' + data.id, data)
  },
  remove (id) {
    return Vue.http.delete(this.url + '/' + id)
  },
  statuses () {
    return [{
      id: 1,
      name: 'Szkic'
    }, {
      id: 2,
      name: 'Przeznaczona do wysłania'
    }]
  },
  allStatuses () {
    return [{
      id: 1,
      name: 'Szkic'
    }, {
      id: 2,
      name: 'Przeznaczona do wysłania'
    }, {
      id: 3,
      name: 'W trakcie wysyłania'
    }, {
      id: 4,
      name: 'Wysłana'
    }]
  },
  getBaseItem () {
    return {
      id: null,
      title: '',
      text_body: '',
      html_body: '',
      email_account_id: null,
      template_html: null,
      template_text: null,
      email_groups_ids: [],
      status: 1,
      use_template: true,
      send_to_all: true,
      send_to_confirmed: true,
      send_to_notconfirmed: false,
      send_to_imported: false,
      send_to_signout: false,
      import_html_url: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Messages.js